export const nav = [
    {
      text: "home",
      path: "/",
    },
    {
      text: "about",
      path: "/about",
    },
 
    {
      text: "contact",
      path: "/contact",
    },
  ]
  export const featured = [
    {
      cover: "../images/hero/h1.png",
      name: "Egypt Travel Packages",
      total: "Egypt has always been an important tourist destination for the best trips in Egypt.",
    },
    {
      cover: "../images/hero/h2.png",
      name: "Egypt Nile Cruises",
      total: "Egypt has always been an important tourist destination for the best trips in Egypt.",
    },
    {
      cover: "../images/hero/h3.png",
      name: "Egypt Excursions",
      total: "Egypt has always been an important tourist destination for the best trips in Egypt.",
    },
    {
      cover: "../images/hero/h4.png",
      name: "Shor Excursions",
      total: "Egypt has always been an important tourist destination for the best trips in Egypt.",
    },
    
  ]
  export const list = [
    {
      id: 1,
      cover: "../images/list/p-1.png",
      name: "Luxor Nights",
      location: "Luxor Governorate, Egypt",
      category: "Ticket Available",
      price: "$700",
      type: "5 Nights",
    },
    {
      id: 2,
      cover: "../images/list/p-2.png",
      name: "Aswan Grand Hotel",
      location: "Aswan Governorate, Egypt",
      category: "Tickets Available",
      price: "$950",
      type: " 3 Days",
    },
    {
      id: 3,
      cover: "../images/list/p-7.png",
      name: "Abu Somboul & Karnak Museums",
      location: "Luxor & Aswan, Egypt",
      category: "Tickets Available",
      price: "$5,860",
      type: "7 Nights",
    },
    {
      id: 4,
      cover: "../images/list/p-4.png",
      name: "Grand Nile Cruise",
      location: "Aswan Governorate, Egypt",
      category: "Tickets Available",
      price: "$740",
      type: "1 Day",
    },
    {
      id: 5,
      cover: "../images/list/p-5.png",
      name: "Luxor Relaxing Holiday",
      location: "Luxor Governorate, Egypt",
      category: "Tickets Available",
      price: "$4,850",
      type: "10 Nights",
      
    },
    {
      id: 6,
      cover: "../images/list/p-6.png",
      name: "Hurghada Picnic",
      location: "Hurghada, Egypt",
      category: "Tickets Available",
      price: "$2,742",
      type: "5 Days",
    },
  ]
  export const awards = [
    {
      icon: <i class='fa-solid fa-trophy'></i>,
      num: "32 M	",
      name: "Blue Burmin Award",
    },
    {
      icon: <i class='fa-solid fa-briefcase'></i>,
      num: "43 M",
      name: "Mimo X11 Award",
    },
    {
      icon: <i class='fa-solid fa-lightbulb'></i>,
      num: "51 M",
      name: "Australian UGC Award",
    },
    {
      icon: <i class='fa-solid fa-heart'></i>,
      num: "42 M",
      name: "IITCA Green Award",
    },
  ]
  export const location = [
    {
      id: 1,
      name: "Cairo",
      Villas: "55 Hotels",
      Apartments: "42 Museum",
      Offices: "",
      cover: "./images/location/city-1.png",
    },
    {
      id: 2,
      name: "Aswan",
      Villas: "12 Hotels",
      Apartments: "10 Museum",
      Offices: "",
      cover: "./images/location/city-2.png",
    },
    {
      id: 3,
      name: "Luxor",
      Villas: "12 Hotels",
      Apartments: " 10 Museum",
      Offices: "",
      cover: "./images/location/city-3.png",
    },
    {
      id: 4,
      name: "Hurghada",
      Villas: "12 Hotels",
      Apartments: " 2 Museum",
      Offices: "",
      cover: "./images/location/city-4.png",
    },
    {
      id: 5,
      name: "Dahab",
      Villas: "12 Hotels",
      Apartments: " 0 Museum",
      Offices: "",
      cover: "./images/location/city-5.png",
    },
    {
      id: 6,
      name: "Sharm AL-Sheikh",
      Villas: "12 Hotels",
      Apartments: " 10 Musuem",
      Offices: "",
      cover: "./images/location/city-6.png",
    },
  ]
  export const team = [
    {
      list: "50",
      cover: "../images/customer/team-1.jpg",
      address: "Liverpool, Canada",
      name: "Sargam S. Singh",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "70",
      cover: "../images/customer/team-2.jpg",
      address: "Montreal, Canada",
      name: "Harijeet M. Siller",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "80",
      cover: "../images/customer/team-3.jpg",
      address: "Denever, USA",
      name: "Anna K. Young",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "51",
      cover: "../images/customer/team-4.jpg",
      address: "2272 Briarwood Drive",
      name: "Michael P. Grimaldo",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "42",
      cover: "../images/customer/team-5.jpg",
      address: "2272 Briarwood Drive",
      name: "Michael P. Grimaldo",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "38",
      cover: "../images/customer/team-5.jpg",
      address: "Montreal, USA",
      name: "Adam K. Jollio",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
  ]
  export const price = [
    {
      plan: "Basic",
      price: "29",
      ptext: "per user, per month",
      list: [
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "99.5% Uptime Guarantee",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "120GB CDN Bandwidth",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "5GB Cloud Storage",
        },
        { change: "color", icon: <i class='fa-solid fa-x'></i>, text: "Personal Help Support" },
        { change: "color", icon: <i class='fa-solid fa-x'></i>, text: "Enterprise SLA" },
      ],
    },
    {
      best: "Best Value",
      plan: "Standard",
      price: "49",
      ptext: "per user, per month",
      list: [
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "99.5% Uptime Guarantee",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "150GB CDN Bandwidth",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "10GB Cloud Storage",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "Personal Help Support",
        },
        {
          change: "color",
          icon: <i class='fa-solid fa-x'></i>,
          text: "Enterprise SLA",
        },
      ],
    },
    {
      plan: "Platinum",
      price: "79",
      ptext: "2 user, per month",
      list: [
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "100% Uptime Guarantee",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "200GB CDN Bandwidth",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "20GB Cloud Storage",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "Personal Help Support",
        },
        {
          icon: <i class='fa-solid fa-check'></i>,
          text: "Enterprise SLA",
        },
      ],
    },
  ]
  export const footer = [
    {
      title: "LAYOUTS",
      text: [{ list: "Home Page" }, { list: "About Page" }, { list: "Service Page" }, { list: "Property Page" }, { list: "Contact Page" }, { list: "Single Blog" }],
    },
    {
      title: "ALL SECTIONS",
      text: [{ list: "Headers" }, { list: "Features" }, { list: "Attractive" }, { list: "Testimonials" }, { list: "Videos" }, { list: "Footers" }],
    },
    {
      title: "COMPANY",
      text: [{ list: "About" }, { list: "Blog" }, { list: "Pricing" }, { list: "Affiliate" }, { list: "Login" }, { list: "Changelog" }],
    },
  ]